import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContenedorComponent } from '../contenedor/contenedor.component';
import { authGuardSubmodule } from '../../auth/auth.guard';

import { TendenciaComponent } from './tendencia/tendencia.component';
import { PerfilComponent } from './perfil/perfil.component';
import { MetasComponent } from './metas/metas.component';

const routes: Routes = [
  {
      path: 'app/captacion-comercial',
      component: ContenedorComponent,
      children: [
        {path: 'tendencia', component: TendenciaComponent, canActivate:[authGuardSubmodule]},
        {path: 'perfil', component: PerfilComponent, canActivate:[authGuardSubmodule]},
        {path: 'metas', component: MetasComponent, canActivate:[authGuardSubmodule]},
      ],
    },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CaptacionComercialRoutingModule { }
